import React from 'react';
import Page from 'components/Page/Page'

export default function Ibm() {
    return (
        <Page>
            IBM
        </Page>
    )
}